import { format, isValid, parse } from "date-fns";

export type TimezoneMode = "local" | "utc";

// Matches existing mock strings like "15/12/2025, 00:06:30"
const AU_DATE_TIME_FORMAT = "dd/MM/yyyy, HH:mm:ss";

function parseMaybeAuDateTime(value: string): Date | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const parsed = parse(trimmed, AU_DATE_TIME_FORMAT, new Date());
  if (isValid(parsed)) return parsed;

  const fallback = new Date(trimmed);
  return isValid(fallback) ? fallback : null;
}

export function formatDateTime(
  value: string | Date | undefined,
  timezone: TimezoneMode,
): string {
  if (!value) return "-";

  const date = typeof value === "string" ? parseMaybeAuDateTime(value) : value;
  if (!date || !isValid(date)) return typeof value === "string" ? value : "-";

  if (timezone === "utc") {
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60_000);
    return `${format(utcDate, AU_DATE_TIME_FORMAT)} UTC`;
  }

  return format(date, AU_DATE_TIME_FORMAT);
}

